import {
    root
} from "./const";
import {BASE_URL} from "./const"
import jquery from "jquery"
const $ = jquery
const app = {}
app.toMyJson = function (param) {
    return {
        data: JSON.stringify(param)
    }
};
app.doAjax = function (interFace, type, param, succCallBack) {
    console.log('接口:' + interFace);
    console.log('类型:' + type);
    console.log('输入:' + JSON.stringify(param));
    console.log('函数:' + succCallBack);
    $.ajax({
        url: interFace,
        dataType: 'json',
        //dataType: 'jsonp',
        type: type,
        data: param,
        //timeout: root.timeout,
        beforeSend: function () {
            // app.loader.show();
        },
        success: function (data, status, response) {
            succCallBack(data, status, response);
        },
        complete: function () {
            // app.loader.hide();
        },
        error: function (xhr, type, errorThrown) {
            console.log(xhr, type, errorThrown);
            alert('网络忙，请稍后再试');
        }
    });

}
/*
 * 获取url参数
 * */
app.parseUrlQuery = function (url) {
    var query = {};
    var urlToParse = url || window.location.href;
    var i;
    var params;
    var param;
    var length;
    if (typeof urlToParse === 'string' && urlToParse.length) {
        urlToParse = urlToParse.indexOf('?') > -1 ? urlToParse.replace(/\S*\?/, '') : '';
        params = urlToParse.split('&').filter(function (paramsPart) {
            return paramsPart !== '';
        });
        length = params.length;

        for (i = 0; i < length; i += 1) {
            param = params[i].replace(/#\S+/g, '').split('=');
            query[decodeURIComponent(param[0])] = typeof param[1] === 'undefined' ? undefined : decodeURIComponent(param[1]) || '';
        }
    }
    return query;
}
/*
 *检查token
 * */
app.checkToken = function () {
    if (app.storage.get('key')) {
        return app.storage.get('key');
    } else {
        return false;
    }
};
/*
 *    本地存储
 */
app.storage = {
    set: function (key, jsonObj) {
        localStorage.setItem(key, JSON.stringify(jsonObj));
    },
    get: function (key) {
        var strObj = localStorage.getItem(key);
        return JSON.parse(strObj);
    },
    remove: function (key) {
        localStorage.removeItem(key);
    },
    removeAll: function () {
        localStorage.clear();
    }
}
//用户-微信授权
app.loadWechat = function (code, type) {
    var param = {
        weixin_code: code
    }

    var succCallBack = function (data) {
        if (data.code == 200) {
            app.storage.set('userData', data.data);
            app.storage.set('token', data.data.token);
            if (type == 'qhb') {
                console.log('qhb')
            } else if (type == 'user') {
                console.log('user')
                window.location.href = BASE_URL+'/Regist';
            } else if (type == 'shop') {
                console.log('shop')
                window.location.href = BASE_URL+'/ShopLogin';
            }else{
                console.log('都不是')
            }
        } else {
            alert(data.message);
        }
    }
    return app.doAjax(root.interFace.getWechatCode, 'post', app.toMyJson(param), succCallBack)
};
//设置用户token
app.setUserToken= function(jsonObj){
    return app.storage.set('userToken',jsonObj)
}
//获取用户token
app.getUserToken= function(){
    return app.storage.get('token')
}
//获取B端token
app.getShopToken= function(){
    return app.storage.get('shopToken')
}
export {
    app
}